import { IMyCustomersState } from '@zet/utils/interface'
import { create } from 'zustand'

const useMyCustomersStore = create<IMyCustomersState>((set) => ({
  searchText: '',
  setSearchText: (payload) =>
    set((state) => ({ ...state, searchText: payload })),
  subAgentId: '',
  setSubAgentId: (payload) =>
    set((state) => ({ ...state, subAgentId: payload })),
  sortType: 'creditReport',
  setSortType: (payload) => set((state) => ({ ...state, sortType: payload })),
  nonVerifiedSortType: 'createdAt',
  setNonVerifiedSortType: (payload) =>
    set((state) => ({ ...state, nonVerifiedSortType: payload })),
  sortingOptions: '',
  setSortingOptions: (payload) =>
    set((state) => ({
      ...state,
      sortingOptions: payload,
    })),
  isBrandsFlow: false,
  setIsBrandsFlow: (payload) => set(() => ({ isBrandsFlow: payload })),
  partnerId: 0,
  setPartnerId: (payload) => set(() => ({ partnerId: payload })),
  customerIntent: '',
  setCustomerIntent: (payload) => set(() => ({ customerIntent: payload })),
}))

export default useMyCustomersStore
